import AccessibilitePage from '@/pages/accessibilite/AccessibilitePage.vue'

export default [
  {
  path: '/accessibilite/',
  component: AccessibilitePage,
  props: true
  }
]
